const messages = {
    selectAUser: 'Select a user',
    selectAManager: 'Select a manager',
    assignManager: 'Assign manager',
    assignProvider: 'Assign provider',
    manager: 'Manager',
    managers: 'Managers',
    userPhone: 'User phone',
    userEmail: 'User email',
    lastMessage: 'Last Message',
    lastMessageTime: 'Last Message Time',
    departmentCategory: 'Department Category',
    phoneNumber: 'Phone number',
    media: 'Media',
    twilioSid: 'Twilio Sid',
    sales: 'Sales',
    marketing: 'Marketing',
    coordination: 'Coordination',
    internal: 'Internal',
    recording: 'Recording',
    messageHistory: 'Message history',
    archivedConversations: 'Archived Conversations',
    unlinkedConversations: 'Unlinked Conversations',
    conversationSid: 'Conversation SID',
    contactPhone: 'Contact Phone',
    contactName: 'Contact Name',
    clientLeadId: 'Client Lead ID',
    importHistory: 'Import history',
    userbox: 'Userbox',
    userboxPhone: 'Userbox Phone',
    lastMessageAt: 'Last Message At',
    externalPhone: 'External Phone',
    viewMessages: 'View Messages',
    noArchivedConversations: 'No archived conversations found',
    noUnlinkedConversations: 'No unlinked conversations found',
    selectACategory: 'Select a category',
    addNumber: 'Add number',
    editNumber: 'Edit number',
    editName: 'Edit name',
    nameRequiredHelp: 'Name is required and cannot be blank.',
    unnamedUserbox: 'Unnamed',
    messagingDisabledErrorMessage:
        'Messaging with this number is disabled as it is shared with multiple contacts.',
    messagingParticipantNotFoundMessage:
        'This patient has not been assigned to you for messaging. If you believe this is an error, please contact your system administrator.',
};

export default messages;
